export const getVersion = () => process.env.REACT_APP_APP_VERSION || "";
